(ns com.theplantscape.web-ui.tailwind.gps
  (:require
   [com.theplantscape.svg-generation.ensemble :refer [compass]]
   [com.theplantscape.web-ui.tailwind.buttons
    :refer
    [ui-btn-action ui-btn-toggle]]))

(defn ui-compass-popup [{:keys [geo-position accuracy
                                toggle-gps-value
                                toggle-rotation-value
                                enabled
                                error
                                close-fn
                                toggle-fn
                                toggle-map-rotate-fn]}]
  [:div.w-full
   [:h3.text-2xl.m-4 "Toggle GPS functionality"]
   (if (some? geo-position)
     [:div.w-full
      [:p.m-4 "Enable GPS Follow & rotation"]
      [:div.flex {:class "h-4/5"}
       [:div {:class "w-1/3"} 
        [compass 100 132 enabled]]
       [:div {:class "w-2/3"}
        (prn geo-position)
        [:div (str "Longitude " (first geo-position))]
        [:div (str "Latitude " (second geo-position) )]
        [:div (str "Accuracy confidence " accuracy " meters")]
        [:div (case error
                "1" "Permission denied, application not allowed access to gps positioning"
                "2" "Could not get a fix on your location from gps hardware"
                "3" "Took to long getting your gps location so gave up" "")]]]
      [:div.flex.flex-col
       [:div.m-4.w-half 
        [ui-btn-toggle toggle-gps-value toggle-fn]
        "Toggle GPS functionality"]
       [:div.m-4.w-half 
        [ui-btn-toggle toggle-rotation-value toggle-map-rotate-fn]
        "Toggle Rotation functionality"]]]
     [:div [:div "GPS is not available, either blocked or no hardware device detected"]])
   [:div.m-4.w-half [ui-btn-action "Close" close-fn]]])
